import { FC, ReactNode } from 'react';

import {
  SidebarMenuButton,
  SidebarMenuItem,
} from '@savgroup-front-common/primitive/ui/sidebar';

import { MenuRowContent } from '../../../MenuRowContent/MenuRowContent';

interface NavigationDrawerRowProps {
  icon: ReactNode;
  trailingIcon?: ReactNode;
  onClick: () => void;
  dataTestId: string;
  variant?: 'default' | 'destructive';
  children: ReactNode;
}

export const NavigationDrawerRow: FC<NavigationDrawerRowProps> = ({
  icon,
  trailingIcon,
  onClick,
  dataTestId,
  variant = 'default',
  children,
}) => {
  return (
    <SidebarMenuItem>
      <SidebarMenuButton
        onClick={onClick}
        data-testid={dataTestId}
        variant={variant === 'destructive' ? 'destructive' : 'muted'}
        className="h-auto cursor-pointer gap-3 rounded-sm px-3 py-2.5 text-left text-base font-normal"
      >
        <MenuRowContent
          icon={icon}
          trailingIcon={trailingIcon}
          variant={variant}
        >
          {children}
        </MenuRowContent>
      </SidebarMenuButton>
    </SidebarMenuItem>
  );
};
